import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=65a0c081&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=65a0c081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0c081",
  null
  
)

export default component.exports